@import 'close';

.alert {
	margin-bottom: 0;
	border-radius: 0;
	padding: $spacer 0;


	&-dismissible {

		.container {
			position: relative;
			padding-right: 3rem;
		}

	}

	&.has-icon {
		
		> .container {
			display: flex;
			flex-direction: row;
		}

		.alert-icon {
			height: 25px;
			margin: auto 1rem auto 0;
			kdx-icon {
				width: 20px;
				height: 100% !important;
				display: block;
				svg {
					@include svg-format(100%, 100%, $secondary);
					min-height: 100%;
				}
			}
		}
	}

	// Client Scope
	&.kdx-alert {
		background-color: $tertiary;
		border: none;
		padding: 1rem 3.125rem;
		&.alert-primary {
			background-color: $white;
			border-bottom: 2px solid $primary;

			.container {
				strong { color: $primary; }
			}
			&.has-icon {
				.alert-icon {
					kdx-icon {
						svg { fill: $primary; }
					}
				}
			}
		}
		&.alert-secondary {
			background-color: $white;
			border-bottom: 2px solid #A30000;
			.container {
				strong { color: #A30000; }
			}
			&.has-icon {
				.alert-icon {
					svg { fill: #A30000 !important; }
				}
			}
		}

		.container {
			justify-content: space-between;
			padding: 0;
			max-width: 100%;
			p {
				margin: 0 0.5rem;
				padding: 0;
				color: $font-gray;
				line-height: unset;
			}
	
			a {
				color: $secondary;
				text-decoration: none;
				font-weight: 600;
				&:hover,
				&:focus {
					text-decoration: underline;
				}
			}

			.alert-links {
				height: fit-content;
				margin: auto 0 auto 1rem;
				button.close-btn {
					background: transparent;
					padding: 0;
					.svg-icon {
						display: block;
						
						kdx-icon {
							width: 25px;
							display: block;

							svg {
								@include svg-format(25px, 25px, $primary);
							}
						}
					}
					&:focus {
						outline: 2px solid $white;
					}
				}
			}
		}

		[class^="arrow-link"] {
			@include text-size(12);

			.svg-icon {
				margin-right: 0;
			}

			&:last-child {
				margin: 8px 0 0;
			}
		}
	}

	@include media-breakpoint-down(md) {
		&-dismissible {
			.btn-close {
				padding: 0;
				top: calc((-1 * #{$spacer}) + #{$gutter-def});
				right: 35px;
				background-size: 13px 13px;
			}
		}

		&.kdx-alert {

			&.has-icon {
				> .container {
					padding: 0;
				}
			}
		}
	}
}
